/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
// import { useLocation } from '@reach/router'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { imageUrlFor } from '../../lib/image-url'
import { buildImageObj } from '../../lib/helpers'
import SchemaOrg from './schema-org'

function SEO({
  siteMetadata: site,
  description,
  datePublished,
  dateModified,
  lang,
  meta,
  image,
  isBlogPost,
  keywords,
  title,
  pathname,
  canonical,
}) {



  // const { site } = useStaticQuery(graphql`
  //   query {
  //     site {
  //       siteMetadata {
  //         title
  //         description
  //         keywords
  //         image
  //         author {
  //           name
  //           minibio
  //         }
  //         organization {
  //           name
  //           url
  //           logo
  //         }
  //         siteUrl
  //         social {
  //           twitter
  //           fbAppID
  //         }
  //       }
  //     }
  //   }
  // `)
  //  console.log(site)
  //  console.log("title",title);
  //  console.log("site.title",site.title)
  //  console.log("site.siteMetadata.title",site.siteMetadata.title)
  //  console.log("siteTitle.length",title.length);

  const metaDescription = description || (site && site.description) || (site && site.siteMetadata.description) || ''
  const siteTitle = (title) || (site && site.siteMetadata.title) || (site && site.title) || ''
  const siteAuthor = (site && site.author && site.author.name) || (site && site.siteMetadata.author.name) || ''
  //const metaImageSite = site && site.siteMetadata.image;
  const metaImageSite = (image && image.asset) ? imageUrlFor(buildImageObj(image)).width(1200).url() : ''
  //TODO: check and siteAuthor
  // console.log("metaImageSite",metaImageSite);
  // console.log("isBlogPost",isBlogPost)
  // console.log("pathname",pathname);
  // console.log("image",image);
  // console.log("siteAuthor",siteAuthor);
  return (
    <>
      <Helmet
        htmlAttributes={{ lang }}
        title={siteTitle}
        titleTemplate={
          title && title.length < 60
            ? `%s | ${site.title}`
            : ''
        }

        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },

          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: siteAuthor,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ]
          // check concat
          .concat(
            image
              ? [
                {
                  property: `og:image`,
                  content: metaImageSite,
                },
                {
                  property: 'og:image:width',
                  content: metaImageSite.width,
                },
                {
                  property: 'og:image:height',
                  content: metaImageSite.height,
                },
                {
                  name: 'twitter:card',
                  content: 'summary_large_image',
                },
              ]
              : [
                {
                  name: 'twitter:card',
                  content: 'summary',
                },
              ]
          )
          .concat(
            keywords && keywords.length > 0
              ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
              : []
          )
          .concat(meta)}
      >

        <link rel="canonical" href={`${canonical}/`} />

      </Helmet>
      <SchemaOrg
        isBlogPost={isBlogPost}
         url={canonical}
         title={title}
         image={image && image.src}
         description={description}
         datePublished={datePublished} //"datePublished": "2009-05-08",
         dateModified={dateModified} //"dateModified": "2009-05-08",
         canonical={canonical}
         author={siteAuthor} //"author": "John Smith",
         organization={site.organization}
         defaultTitle={site.title}

      />
    </>
  )
}


function SEOWithQuery(props) {
  const {
    site: {siteMetadata},
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description

          keywords
          image
          author {
            name
            minibio
          }
          organization {
            name
            url
            logo
          }
          siteUrl
          social {
            twitter
            fbAppID
          }
        }
      }

    }
  `)
  return <SEO siteMetadata={siteMetadata} {...props} />
}

SEOWithQuery.propTypes = {
  isBlogPost: PropTypes.bool,
  postData: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      frontmatter: PropTypes.any,
      excerpt: PropTypes.any,
    }),
  }),
  metaImage: PropTypes.string,
}

SEOWithQuery.defaultProps = {
  isBlogPost: false,
  postData: {childMarkdownRemark: {}},
  metaImage: null,
}

export default SEOWithQuery

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  // image: PropTypes.shape({
  //   src: PropTypes.string.isRequired,
  //   height: PropTypes.number.isRequired,
  //   width: PropTypes.number.isRequired,
  // }),
  canonical: PropTypes.string,
  // pathname: PropTypes.string,
}
